// src/api/AuthApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './customBaseQuery';
import { endpoint } from './endpoint';

const AuthApi = createApi({
  reducerPath: 'AuthApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL, // Base URL from environment variables
  }),
  tagTypes: ['Auth', 'User'],

  endpoints: (builder) => ({
    // Login
    login: builder.mutation({
      query: (credentials) => ({
        url: `${endpoint.auth}login`,
        method: 'POST',
        data: credentials,
      }),
      invalidatesTags: ['User'],
    }),

    // Register
    register: builder.mutation({
      query: (userData) => ({
        url: `${endpoint.auth}register`,
        method: 'POST',
        data: userData,
      }),
    }),

    // Request password reset email
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `${endpoint.auth}password-reset`,
        method: 'POST',
        data,
      }),
    }),

    // Confirm password reset with token
    confirmPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${endpoint.auth}password-reset/confirm`,
        method: 'POST',
        data,
      }),
    }),

    // Refresh Token
    refreshToken: builder.mutation({
      query: ({ token }) => ({
        url: `${endpoint.auth}refresh-token`,
        method: 'POST',
        data: {
          refresh: token,
        },
      }),
    }),

    // Sign Out
    signOut: builder.mutation({
      query: ({ token }) => ({
        url: `${endpoint.auth}logout`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token.access}`,
        },
        data: {
          refresh: token.refresh,
        },
      }),
      invalidatesTags: ['User'],
    }),

    // Get User by Token
    getUserByToken: builder.query({
      query: ({ token, page_no, page_size }) => ({
        url: `${endpoint.auth}user-info`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page_no,
          size: page_size,
        },
      }),
      providesTags: ['User'],
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useConfirmPasswordResetMutation,
  useRefreshTokenMutation,
  useSignOutMutation,
  useGetUserByTokenQuery,
} = AuthApi;

export default AuthApi;
